import React from 'react';
import { Box, Button, makeStyles, Skeleton } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { Layout } from './Layout';
import { ProgressBar } from './ProgressBar';

const useStyles = makeStyles((theme: HCPTheme) => ({
  skeleton: {
    marginTop: theme.spacing(3),
  },
}));

export const ListSkeleton = () => {
  const { skeleton } = useStyles();

  return (
    <Layout
      Header={
        <Box mt={5}>
          <ProgressBar value={1} maxValue={5} />
        </Box>
      }
      ContentComponent={
        <Box my={2} data-testid="ListSkeleton__container">
          {[0, 1].map((key) => (
            <Box key={key} mt={2}>
              <Skeleton
                className={skeleton}
                variant="rect"
                height={24}
                aria-label="Loading"
                role="status"
                aria-live="polite"
              />
              <Skeleton
                className={skeleton}
                variant="rect"
                height={85}
                aria-label="Loading"
                role="status"
                aria-live="polite"
              />
            </Box>
          ))}
        </Box>
      }
      Buttons={
        <Button version="v2" size="large" fullWidth variant="contained" color="secondary" disabled>
          Next
        </Button>
      }
    />
  );
};
